import { APP_THEME_FOURTEEN, WHITE } from "../../consts/colors";

export const styles = {
  loginSubContainer: {
    maxWidth: "550px",
    width: "100%",
    "@media (max-width: 600px)": {
      padding: "0px 20px",
    },
  },
  container: {
    marginTop: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    // gap: "60px",
    padding: "0px 1.5rem",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    width: "100%",
  },
  formTitle: {
    color: WHITE,
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: "2px",
  },
  formSubtitle: {
    color: "rgba(255, 255, 255, 0.65)",
    fontSize: "12px",
  },
  loginFormContainer: {
    marginTop: "30px",
    width: "100%",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  labelAndInputBox: {
    marginBottom: "1rem",
  },
  labelInputProp: {
    color: WHITE,
  },
  showPasswordContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  forgetPasswordText: {
    fontSize: "13px",
    fontWeight: "500",
    lineHeight: "24px",
    color: "white",
    "@media (min-width: 2000px)": {
      fontSize: "14px",
    },
    cursor: "pointer",
  },
  signupPromptContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "16px",
  },
  signupPromptText: {
    fontSize: "13px",
    fontWeight: "500",
    color: "white",
    "@media (min-width: 2000px)": {
      fontSize: "14px",
    },
  },
  signupLink: {
    fontSize: "13px",
    fontWeight: "700",
    color: "white",
    textDecoration: "underline",
    cursor: "pointer",
    marginLeft: "6px",
    "@media (min-width: 2000px)": {
      fontSize: "14px",
    },
  },
  loginButton: {
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "24px",
    backgroundColor: WHITE,
    color: APP_THEME_FOURTEEN,
    height: "40px",
    textTransform: "capitalize",
    borderRadius: "20px",
    width: "127px",
    padding: "12px",
    "@media (max-width: 600px)": {
      width: "127px",
    },
    "&:hover": {
      backgroundColor: WHITE,
    },
  },
  loginButtonContainer: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
    marginBottom: "16px",
  },
  forgetPasswordContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  errorMessageContainer: {
    position: "relative",
    width: "100%",
  },
};
